import React, {useState, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import Footer from '../../components/Footer'
import Navbar from '../../components/Navbar'
import PreNav from '../../components/PreNav'
import { getOrderDetails } from '../../redux/actions/orderAction'
import Loading from '../util/Loading'
import Razorpay from './Razorpay'

const Payments = () => {

    const dispatch = useDispatch()
    const {orderId} = useParams()
    const {order} = useSelector(state=>state.orders)
    const [loading, setLoading] = useState(true)
    const [isPaid, setIsPaid] = useState(false)
    const [loadRazorpay, setLoadRazorpay] = useState(false)
    const [error, setError] = useState("")

    useEffect(() => {
      dispatch(getOrderDetails(orderId))
      .then(res=>{
        setLoading(false)
        if (res.success) {
            checkForPaymentStatus(res.order.paymentInfo.status)
        } else {
            setError(res.message)
        }
      })
    }, [])

    const checkForPaymentStatus = (orderStatus) => {
        if (orderStatus === "Paid") {
            setIsPaid(true)
        } else {
            setLoadRazorpay(true)
        }
    }
  
    return (
    loading ? <Loading/> : 
    <>
        <PreNav/>
        <Navbar/>
        <section className='py-7'>
            <div className="container">
                <div className="row">
                    {error ? 
                        <div className="col-12 text-center flex-column d-flex justify-content-center align-items-center" style={{minHeight:"50vh"}}>
                            <div className="mb-7 font-size-h1">🙁</div>
                            <h2 className="mb-5">Some error occured</h2>
                            <p className="mb-7 text-danger">{error}</p>
                            <a className="btn btn-dark" href="/">Go to Homepage</a>
                        </div>
                    : isPaid ? 
                        <div className="col-12 text-center flex-column d-flex justify-content-center align-items-center" style={{minHeight:"50vh"}}>
                            <div className="mb-7 font-size-h1">❤️</div>
                            <h2 className="mb-5">Your Order is successfully placed!</h2>
                            <p className="mb-7 text-gray-500">Your order has successfully placed. View detils on your dashboard.</p>
                            <a className="btn btn-dark" href="/user/myorders">View My Orders</a>
                        </div>
                    :   <div className="col-12 text-center flex-column d-flex justify-content-center align-items-center" style={{minHeight:"50vh"}}>
                            <p className="mb-5">Processing Payment...</p>
                            {loadRazorpay && <Razorpay number={order.shippingInfo.phoneNumber} email={order.user.email} name={order.user.name} amount={order.totalPrice} orderId={orderId} />}
                        </div>}
                </div>
            </div>
        </section>
        <Footer/>
    </>
  )
}

export default Payments